var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('g-vue-table',{attrs:{"apiIndexUrl":'/api/customers/' + _vm.obj.id + '/newsletters',"sortBy":"name","columns":_vm.columns,"obj":_vm.obj,"hasExports":true},on:{"download":_vm.download}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }